import { baseQuery } from '../baseQuery';

type DiscountUpdateParams = {
  discountId: number;
  expiryDate?: string;
  active?: number;
};

export const putDiscount = async ({ discountId, expiryDate, active }: DiscountUpdateParams) => {
  const { data } = await baseQuery('customer-discount', {
    type: 'PUT',
    body: {
      id: discountId,
      expiry_date: expiryDate,
      active,
    },
  });

  return data;
};
